'use client'
import { H1, Spinner } from '@/components/ui';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

export default function NotFound() {
  const router = useRouter();

  useEffect(() => {
    setTimeout(() => router.replace('/'), 2000);
  }, [router]);

  return (
    <div className='flex gap-4 justify-center items-center text-center'>
      <Spinner />
      <H1>Redirecionando...</H1>
    </div>
  )
}